@import '~style-sheet-helpers/core.less';

.button {
  margin-left: auto;
}

.wrapper {
  align-items: center;
}

.icon {
  height: 12px;
}
